// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__2Jcnq","large":"styles_large__3nyaV"};